<template>
    <div ref="scroller" class="listener-legacy-panel" @scroll.passive="listenBottomOut">
        <div class="flex justify-between mb-1">
            <div class="text-2xl">: {{ artist }}</div>
        </div>

        <div class="segmented-tabs segmented-tabs--bar mb-2">
            <a v-for="{ value, text } in options" :key="value"
                :class="['segmented-tab', section === value ? 'is-active' : '']">
                <div @click="handleChangeTab(value)">
                    {{ $tt(text) }}
                </div>
            </a>
        </div>

        <template v-if="section === 'tracks'">
            <TrackList :tracks="tracks" :index-field="'index'" />
        </template>
        <template v-else>
            <AlbumList :items="albums" />
        </template>
        <div class="flex justify-center" v-if="loading">
            <span class="loading loading-infinity loading-lg"></span>
        </div>
        <button
            v-if="curScrollTop > 700"
            @click="scrollToTop"
            class="fixed bottom-28 right-4 bg-neutral-content hover:bg-accent hover:text-accent-content text-neutral font-bold py-2 px-4 rounded-full shadow-xl transition-colors duration-300"
        >
            <svg t="1730534469934" class="icon h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2399" width="200" height="200"><path d="M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3c-3.8 5.3-0.1 12.7 6.5 12.7h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" p-id="2400"></path></svg>
        </button>
    </div>
</template>

<script>
import AlbumList from '@/views/library/album/AlbumList.vue'
import TrackList from '@/views/library/track/TrackList.vue'

export default {
    name: 'ListenerArtistTracks',
    components: {
        AlbumList,
        TrackList
    },
    data() {
        return {
            tracks: [],
            albums: [],
            id: this.$route.params.id,
            artist: this.$route.query.name,
            section: 'albums',
            loading: false,
            offset: 0,
            hasMore: true,
            loading2: false,
            offset2: 0,
            hasMore2: true,
            curScrollTop: 0,
            options: [
                { text: '专辑', value: 'albums' },
                { text: '歌曲', value: 'tracks' }
            ]
        }
    },
    async created() {
        await this.loadMore()
    },
    activated() {
        this.$nextTick(() => {
            if (this.$refs.scroller) {
                this.$refs.scroller.scrollTop = this.curScrollTop || 0
            }
        })
    },
    methods: {
        async loadAlbums(offset) {
            this.albums = await this.$api.subsonic.getAlbumsByArtist(this.id, 50, offset)
        },
        async loadTracks(offset) {
            this.tracks = await this.$api.subsonic.getTracksByArtist2(this.id, 50, offset)
        },
        handleChangeTab(value) {
            this.section = value
            this.loadMore()
        },
        handleDelete() {
            this.$api.Task.deleteGenre({ id: this.id }).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('删除成功！'),
                        type: 'success',
                        time: 2000,
                    })
                    this.$router.push({ path: '/genres/a-z/' })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('删除失败！'),
                        type: 'error',
                        time: 2000,
                    })
                }
            })
        },
        loadMore() {
            if (this.section === 'tracks') {
                this.loading2 = true
                return this.$api.subsonic.getTracksByArtist2(this.id, 50, this.offset2).then(tracks => {
                    this.tracks.push(...tracks)
                    this.offset2 += tracks.length
                    this.hasMore2 = tracks.length > 0
                    this.loading2 = false
                })
            }
            this.loading = true
            return this.$api.subsonic.getAlbumsByArtist(this.id, 50, this.offset).then(albums => {
                this.albums.push(...albums)
                this.offset += albums.length
                this.hasMore = albums.length > 0
                this.loading = false
            })
        },
        listenBottomOut() {
            let hasMore
            let loading
            if (this.section === 'albums') {
                hasMore = this.hasMore
                loading = this.loading
            } else {
                hasMore = this.hasMore2
                loading = this.loading2
            }
            if (hasMore && !loading && this.$refs.scroller) {
                const scroller = this.$refs.scroller
                const scrollTop = scroller.scrollTop
                const scrollHeight = scroller.scrollHeight
                const clientHeight = scroller.clientHeight
                this.curScrollTop = scrollTop
                if (scrollTop + clientHeight >= scrollHeight - 50) {
                    this.loadMore()
                }
            }
        },
        scrollToTop() {
            if (this.$refs.scroller) {
                this.$refs.scroller.scrollTo({ top: 0, behavior: 'smooth' })
            }
        }
    }
}
</script>

<style scoped>
.listener-legacy-panel {
    height: calc(100dvh - 12.25rem);
    box-sizing: border-box;
    padding: 0.2rem 0 0.25rem;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
</style>
